import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQ_GROUPS } from "../data/site";
import FinalCTA from "../components/FinalCTA";

// Display categories in this order
const CATEGORY_ORDER = [
  "General Questions",
  "Swim Lessons",
  "Agua Flow Swim Academy",
  "Lifeguard Services",
];

const orderedGroups = CATEGORY_ORDER.map((cat) =>
  FAQ_GROUPS.find((g) => g.category === cat),
).filter(Boolean);

export default function FAQPage() {
  return (
    <div data-testid="faq-page">
      <section className="aqua-section pb-12">
        <div className="aqua-container max-w-3xl">
          <p className="text-eyebrow">FAQ</p>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold mt-3 text-[#0B2F6B] leading-tight">
            Common questions from clients.
          </h1>
          <p className="mt-5 text-[#3B5878] text-base sm:text-lg leading-relaxed">
            Don't see your question here? Reach out — we love to chat with
            families before they book.
          </p>
        </div>
      </section>

      <section className="pb-20">
        <div className="aqua-container max-w-3xl space-y-12">
          {orderedGroups.map((group, gi) => (
            <div key={group.category} data-testid={`faq-group-${gi}`}>
              <div className="flex items-center gap-3 mb-5">
                <span className="w-8 h-1.5 rounded-full" style={{ backgroundColor: "#33BED6" }} />
                <h2 className="font-heading text-xl sm:text-2xl font-semibold text-[#0B2F6B]">
                  {group.category}
                </h2>
              </div>
              <Accordion
                type="single"
                collapsible
                className="space-y-3"
                data-testid={`faq-accordion-${gi}`}
              >
                {group.items.map((item, i) => (
                  <AccordionItem
                    key={i}
                    value={`g${gi}-item-${i}`}
                    className="card-soft px-6 sm:px-7 border"
                    data-testid={`faq-item-${gi}-${i}`}
                  >
                    <AccordionTrigger className="font-heading text-left text-base sm:text-lg font-semibold text-[#0B2F6B] hover:no-underline py-5">
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-[#3B5878] text-base leading-relaxed pb-5">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>
          ))}
        </div>
      </section>

      <FinalCTA />
    </div>
  );
}
